import { createContext, useEffect, useState } from "react";
  
interface IProps {
  children: React.ReactNode;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  refresh_expires_in: number;
  user_id: string;
  email:string;
  user_name:string;
  full_name:string;
  role:string;
  user_profile_image:string;
  is_email_verified:boolean;
  disabled:boolean;
}

export interface IAuthContext {
  user: LoginResponse | null;
  access_token?: string;
  refresh_token?: string;
  setUser: (user: LoginResponse | null) => void;
  rememberMe: string | null;
  setRememberMe: (remember: string) => void;
}

export const AuthContext = createContext<IAuthContext>({} as IAuthContext);

const AuthProvider = ({ children }: IProps) => {
  const userData: string | null = localStorage.getItem("user");

  const userDetails: LoginResponse | null = userData
    ? JSON.parse(userData)
    : null;

  const userRememberMe: any = JSON.parse(
    localStorage.getItem("userRememberMe") ?? "{}"
  );

  const [user, setUser] = useState<LoginResponse | null>(userDetails);
  const [rememberMe, setRememberMe] = useState<string | null>(userRememberMe);

  useEffect(() => {
    const userData: string | null = localStorage.getItem("user");
    const userDetails: LoginResponse | null = userData
      ? JSON.parse(userData)
      : null;

    setUser(userDetails);
  }, [userData]);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        rememberMe,
        setRememberMe,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
